define([
    // 'WebCommon/component/page-header-new',
    // 'WebCommon/component/page-footer-new',
    'WebCommon/component/page-header2024',
    'WebCommon/component/page-footer-new',

    'WebCommon/init',
    'css!WebCommon/css/global.css',
    'css!WebCommon/css/common.css'
], function(
    // PageHeaderPhone,
    PageHeader,
    PageFooter
){
    return {
        components: {
            // PageHeaderPhone: PageHeaderPhone,
            PageHeader: PageHeader,
            PageFooter: PageFooter
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ../common/mixin/page.js
// module id = 22
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24